const actions = {
  init({ dispatch }) {
    return new Promise(async(resolve, reject) => {
      try {
        await dispatch('goods/init', {}, { root: true })
        await dispatch('dept/init', {}, { root: true })
        await dispatch('storage/init', {}, { root: true })
        await dispatch('dict/init', {}, { root: true })
        resolve()
      } catch(error) {
        reject(error)
      }
      // Promise.all([
      //   dispatch('goods/init', {}, { root: true }),
      //   dispatch('dept/init', {}, { root: true }),
      //   dispatch('storage/init', {}, { root: true }),
      //   dispatch('dict/init', {}, { root: true })
      // ]).then(_ => {
      //   resolve()
      // }).catch(error => reject(error))
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js